/*global jQuery*/
/*eslint no-undef: "error"*/

import React from 'react';
import {RefinementListFilter} from 'searchkit'
import ReactTooltip from 'react-tooltip'

var react_1 = require("./core/react");

class CustomRefinementListFilter extends RefinementListFilter {
  addTooltips(key) {
    const hostName = this.searchkit.options.getLocation().hostname;
    if (!hostName.includes('localhost')) {
      switch (key) {
        case 'form_name':
          return window.drupalSettings.regofix_tooltips.form_name;
        case 'b_height_mm':
          return window.drupalSettings.regofix_tooltips.b_height_mm;
        case 'bore_diameter_decimal_inch':
          return window.drupalSettings.regofix_tooltips.bore_diameter_decimal_inch;
        case 'bore_diameter_mm':
          return window.drupalSettings.regofix_tooltips.bore_diameter_mm;
        case 'field_bore_o_mm_':
          return window.drupalSettings.regofix_tooltips.field_bore_o_mm_;
        case 'field_bore_o_inch_':
          return window.drupalSettings.regofix_tooltips.field_bore_o_inch_;
        case 'c_thread':
          return window.drupalSettings.regofix_tooltips.c_thread;
        case 'norm_size':
          return window.drupalSettings.regofix_tooltips.norm_size;
        case 'o_inch':
          return window.drupalSettings.regofix_tooltips.o_inch;
        case 'field_interface_size_name':
          return window.drupalSettings.regofix_tooltips.interface_size;
        case 'lenght_style':
          return window.drupalSettings.regofix_tooltips.length_style;
        case 'field_nominal_size':
          return window.drupalSettings.regofix_tooltips.nominal_size;
        case 'o_mm':
          const productType = this.searchkit.state.product_type ? this.searchkit.state.product_type[0] : null;
          if (productType === 'clamping_nuts_and_disks') {
            return window.drupalSettings.regofix_tooltips.o_mm_clamping_nut;
          }
          else {
            return window.drupalSettings.regofix_tooltips.o_mm;
          }
        default:
          break;
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.operator != this.props.operator) {
      this.accessor.options.operator = this.props.operator;
      this.searchkit.performSearch();
    }

    // Choose first system name filter if request empty
    if (this.accessor.state.getValue().length === 0 && this.accessor.key === "system_name") {
      if(this.accessor.getResults() != null) {
        this.setFilters([this.accessor.getAggregations('system_name3').system_name.buckets[0].key]);
      } else {
        this.setFilters(['ER']);
      }
    }

    // Select Product Type Notice Message block.
    if (this.accessor.key === "product_type") {
      const hostName = this.searchkit.options.getLocation().hostname;
      if (this.accessor.state.getValue().length === 0) {
        if (!hostName.includes('localhost')) {
          jQuery('.filters-expert').addClass('is-disabled');
          jQuery('.select-product-type-notice-message').detach().css('display', 'block').insertAfter('.sk-panel.filter--product_type');
          jQuery('.select-product-type-notice-message .close-button').once().click(function () {
            jQuery(this).parent().fadeOut('slow');
          });
        }
      }
      else {
        if (!hostName.includes('localhost')) {
          jQuery('.select-product-type-notice-message').css('display', 'none');
          jQuery('.filters-expert').removeClass('is-disabled');
        }
      }
    }
  }

  render() {
    var _a = this.props, listComponent = _a.listComponent, containerComponent = _a.containerComponent, collapsable = _a.collapsable, showCount = _a.showCount, title = _a.title, id = _a.id, countFormatter = _a.countFormatter;
    if (this.searchkit.state.product_type) {
      if (this.searchkit.state.product_type.length === 0) {
        let key = this.accessor.key;
        switch (key) {
          case "product_type":
          case "system_name":
            break;
          default:
            return null;
        }
      }
      else {
        const productType = this.searchkit.state.product_type[0];
        const systemName = this.searchkit.state.system_name[0];
        let key = this.accessor.key;
        switch (key) {
          case "o_mm":
          case "o_inch":
            if(productType === "accessories") {
              return null;
            }
            else {
              break;
            }
          case "field_nominal_size":
            if (productType !== "accessories") {
              return null;
            } else {
              break;
            }
          case "lenght_style":
            if(productType === "clamping_nuts_and_disks") {
              return null;
            }
            else {
              break;
            }
          default:
            break;
        }
      }
    }
    const tooltipText = this.addTooltips(this.accessor.key);
    return react_1.renderComponent(containerComponent, {
      title: this.props.select ? "" :title,
      className: id ? "filter--" + id : undefined,
      disabled: !this.hasOptions(),
      collapsable: collapsable ? collapsable : false,
      defaultCollapsed: false

    },
      [
        tooltipText ? <span className="fas fa-question-circle fa-lg tooltip-icon" data-tip={tooltipText} data-for={id}></span> : "",
        <ReactTooltip place="top" id={id} effect='solid' getContent={(dataTip) => `${dataTip}`} delayShow={300}/>,
        react_1.renderComponent(listComponent, {
        key: "listComponent",
        items: this.getItems(),
        itemComponent: this.props.itemComponent,
        selectedItems: this.getSelectedItems(),
        toggleItem: this.toggleFilter.bind(this),
        setItems: this.setFilters.bind(this),
        docCount: this.accessor.getDocCount(),
        showCount: showCount,
        translate: this.translate,
        countFormatter: countFormatter,
        customTitle: this.props.select ? title : "",
      }),
      this.renderShowMore()
    ]);
  }
}

export default CustomRefinementListFilter;



// WEBPACK FOOTER //
// ./src/CustomRefinementListFilter.js